<h2 mat-dialog-title>{{ isStepMode ? 'Modification du produit' : 'Modification multiple de produits' }}</h2>
<mat-dialog-content>
  <div class="flex flex-col gap-4" *ngIf="!isStepMode">
    <mat-form-field appearance="outline">
      <mat-label>Recherche</mat-label>
      <input matInput [formControl]="searchCtrl" placeholder="Rechercher par libellé ou référence" />
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="engagements.length > 1">
      <mat-label>Engagement</mat-label>
      <mat-select [formControl]="engagementCtrl">
        <mat-option value="">Tous</mat-option>
        <mat-option *ngFor="let e of engagements" [value]="e.id">{{ e.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="max-h-60 overflow-auto border p-2" *ngIf="displayedProducts.length">
      <mat-selection-list (selectionChange)="onListChange($event)">
        <mat-list-option *ngFor="let prod of displayedProducts" [value]="prod._id" [selected]="isSelected(prod._id)">
          {{ prod.label }}
          <span class="text-xs text-gray-500" *ngIf="prod.contract?.label">({{ prod.contract.label }})</span>
        </mat-list-option>
      </mat-selection-list>
    </div>
    <div *ngIf="!displayedProducts.length" class="text-center py-4 text-sm text-gray-500">Aucun produit</div>
  </div>
  <div class="flex flex-col gap-4" *ngIf="isStepMode">
    <h3 class="text-base font-medium">
      {{ currentProduct?.label }}
      <span class="text-xs text-gray-500" *ngIf="currentProduct?.contract?.label">
        ({{ currentProduct.contract.label }})
      </span>
    </h3>

    <form [formGroup]="form" class="flex flex-col gap-4">
      <mat-form-field appearance="outline">
        <mat-label>Fin validité</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="endValidityDate" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Libellé</mat-label>
        <input matInput formControlName="label" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Information complémentaire</mat-label>
        <textarea matInput rows="3" formControlName="comment"></textarea>
      </mat-form-field>

      <mat-checkbox formControlName="isAllPerimeter">Tout le périmètre</mat-checkbox>
    </form>

    <div *ngIf="!form.get('isAllPerimeter')?.value" class="mt-4">
      <vex-contract-details-user-perimeter
        [parentItems]="perimeter"
        (selectedItemsChange)="onSelectedItemsChange($event)"
        [isCompressed]="true"
      ></vex-contract-details-user-perimeter>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="closeStep()" *ngIf="isStepMode">Annuler</button>
  <button mat-raised-button color="primary" (click)="saveStep()" *ngIf="isStepMode">Enregistrer</button>
  <button mat-button (click)="close()" *ngIf="!isStepMode">Annuler</button>
  <button
    mat-raised-button
    color="accent"
    (click)="startStepEdit()"
    *ngIf="!isStepMode"
    [disabled]="selection.size === 0"
  >
    Modifier sélection
  </button>
</mat-dialog-actions>
